import { ArrowDown2, IconProps } from "iconsax-react";

const ArrowDown = (props: IconProps) => (<ArrowDown2 size="16" {...props} />)

export default ArrowDown;
